import { render, staticRenderFns } from "./consultant-details.vue?vue&type=template&id=925ed886&scoped=true"
import script from "./consultant-details.vue?vue&type=script&lang=js"
export * from "./consultant-details.vue?vue&type=script&lang=js"
import style0 from "./consultant-details.vue?vue&type=style&index=0&id=925ed886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925ed886",
  null
  
)

export default component.exports